module.exports = __webpack_public_path__ + "media/img/events/location/walking-1cf26d31259e3de85d3b1d723bd26db4.svg";